import { getIconByType } from '@amo/core/utils/functions';
import _ from 'lodash';

const RecapVehicule = (props) => {
    const { data, vehicule, dateMEC, formuleChoisie } = props;

    const getSelectedOptions = () => {
        if (!formuleChoisie?.ListeGaranties) return [];
        const options = _.get(data, 'options') || {};
        const optionsFranchise = _.get(data, 'optionsFranchise') || {};
        const optionsListe = _.get(data, 'optionsListe') || {};

        const selectedCodes = [
            ...Object.values(options),
            ...Object.entries(optionsFranchise)
                .filter(([, v]) => v === 'true')
                .map(([k]) => k),
            ...Object.keys(optionsListe),
        ];

        return selectedCodes
            .map((code) => _.find(formuleChoisie.ListeGaranties, { CodeGarantie: code, Disponible: 'Option' }))
            .filter(Boolean);
    };

    const selectedOptions = getSelectedOptions();

    return (
        <div className="col-lg-4 col-md-6 col-sm-12 border-end mb-3">
            <div className="row">
                <div className="col-2">
                    <img
                        src={getIconByType(data?.typeVehicule)}
                        alt="Véhicule"
                        width={30}
                        loading="lazy"
                    />
                </div>
                <div className="col-10 text-start">
                    <p className="f-14 text-primary fw-bold">
                        Mon véhicule
                    </p>
                    <div className="f-13">
                        <p className="fw-bold">
                            {vehicule.brand?.name} {vehicule.cylindree}
                        </p>
                        <p>{vehicule.modele}</p>
                        <p>Date de mise en circulation : {dateMEC}</p>
                        <p>
                            Stationnement à{' '}
                            {_.get(data, 'DemandeTarif[Vehicule][VilleGarage]')}
                        </p>
                    </div>

                    <br />
                    <p className="f-14 text-primary fw-bold">
                        Mes garanties
                    </p>
                    <div className="f-13">
                        {formuleChoisie?.LibelleFormule && (
                            <p>Formule {formuleChoisie.LibelleFormule}</p>
                        )}
                    </div>

                    {selectedOptions.length > 0 && (
                        <>
                            <br />
                            <p className="f-14 text-primary fw-bold">
                                Mes options
                            </p>
                            <div className="f-13">
                                {selectedOptions.map((option) => (
                                    <p key={option.CodeGarantie}>
                                        {option.LibelleGarantie}
                                    </p>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default RecapVehicule;
